var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.a{stroke:#707070;opacity:0;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10477 3271)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-10477 -3271)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10547 -3268)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(76)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M82.328,0a6.329,6.329,0,0,0-5.384,9.656l5.023,8.095a.527.527,0,0,0,.448.249h0a.527.527,0,0,0,.448-.256l4.9-8.173A6.329,6.329,0,0,0,82.328,0Zm4.53,9.029L82.408,16.46,77.841,9.1a5.277,5.277,0,1,1,9.018-.071Z",
    transform: "translate(-76)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.164 3.164)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M169.164,90a3.164,3.164,0,1,0,3.164,3.164A3.168,3.168,0,0,0,169.164,90Zm0,5.28a2.116,2.116,0,1,1,2.113-2.116A2.118,2.118,0,0,1,169.164,95.28Z",
    transform: "translate(-166 -90)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.c4fb3a0048d59695bdf42fcc384a13ac.svg";
export { ForwardRef as ReactComponent };